import { productIdFormat, supplierIdFormat } from "@redotech/redo-model/ids";
import * as z from "zod/v4";

export const removeProductsFromSupplier = {
  name: "removeProductsFromSupplier" as const,
  input: z.object({
    supplierId: supplierIdFormat.schema,
    productIds: z.array(productIdFormat.schema),
  }),
  output: z.object({ removedCount: z.number().int() }),
};
